export default "__VITE_ASSET__67bf568d__"